import { cva } from "class-variance-authority"

export const terminalControlVariants = cva(
  [
    "inline-flex cursor-pointer items-center justify-center rounded-sm select-none",
    "transition-[color,background-color,border-color,box-shadow] duration-(--duration-fast) ease-(--ease-terminal)",
    "focus-visible:outline-none",
    "data-[state=on]:bg-primary data-[state=on]:text-primary-foreground",
    "data-[state=active]:bg-primary data-[state=active]:text-primary-foreground",
    "aria-pressed:bg-primary aria-pressed:text-primary-foreground",
    "disabled:cursor-not-allowed disabled:opacity-40",
  ],
  {
    variants: {
      size: {
        s: "h-[25px] gap-1 px-2",
        m: "h-7 gap-1.5 px-2.5",
        l: "h-8 gap-1.5 px-3",
        form: "h-12 gap-2 px-4 text-base",
      },
      intent: {
        // Each intent owns its text color: cva joins classes without merging, so a
        // shared muted base would beat the primary intent's own color.
        // The bare control (picks, disclosures) lifts grey; no glow on furniture.
        default:
          "text-muted-foreground hover:bg-accent hover:text-foreground focus-visible:ring-1 focus-visible:ring-ring focus-visible:ring-inset",
        // The quiet bordered control: the same micro uppercase as the primary,
        // a hairline instead of the slab (Cancel, Start monitoring). Under the
        // pointer or keyboard focus it answers in cyan: the hairline turns cyan
        // and takes the rest glow; a press brightens it (Dhanur, 25 Oct 2026).
        quiet:
          "type-micro border-border-strong text-foreground border border-solid hover:border-terminal-accent hover:shadow-(--terminal-glow) focus-visible:border-terminal-accent focus-visible:shadow-(--terminal-glow) active:shadow-(--terminal-glow-strong)",
        // Uppercase like every control (Dhanur, 24 Oct 2026): the cyan slab
        // alone says "action".
        primary:
          "type-micro border border-transparent bg-terminal-accent text-invert-text font-semibold shadow-(--terminal-glow) hover:bg-primary hover:text-primary-foreground hover:shadow-(--terminal-glow-strong) focus-visible:shadow-(--terminal-glow-strong) disabled:opacity-50 disabled:shadow-none",
      },
    },
    defaultVariants: { size: "m", intent: "default" },
  }
)

// The quiet square icon button: the pane toggles and the strand window's
// arrows.
export const terminalIconButtonClassName =
  "text-text-secondary hover:border-border-faint hover:bg-card hover:text-text-primary size-7 shrink-0 border border-transparent bg-transparent px-0"
